<template>
  <div class="introduce">
    <div class="title">产品介绍</div>
    <div class="content">
      <div>
        格灵世界是在线steam课程平台，少年儿童处在培养科学素质和创新思维的黄金时期，格灵世界旨在引导他们利用已掌握的知识和工程技术，采用科学的思维与实践方式解决实际问题。从而培养学生们的高效创新能力，提高竞争力。我们现在做的一切，都是为了帮助孩子们在将来能够从事今天尚未出现的工作。掌握今天尚未发明的技术，解决今天尚未遇到的问题。
      </div>
      <div>
        格灵世界期望凭借科技的力量，构建“教育与社会发展保持现实性和前瞻性相统一“的活动平台。促进青少年知识、能力、思维，与实践的全面发展，培养科学素养和创新能力，提高对自身能力的深度认知，为创造更美好的智能时代作出贡献。
      </div>
    </div>
    <van-image
      fit="cover"
      class="img"
      src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/world/5.png"
    />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '产品介绍'
    },
    desc: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    },
    right: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      data: {
        menu_list: []
      }
    };
  },
  created() {},
  methods: {
    go() {
      this.$router.push({
        name: 'eg'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.introduce {
  width: 1200px;
  background: #9aa4b9;
  margin: 0 auto;
  margin-top: 120px;
  margin-bottom: 36px;
  position: relative;
  padding: 25px;
  box-sizing: border-box;
  color: #fff;
  .title {
    font-size: 36px;
    font-weight: 500;
  }
  .content {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    > div {
      font-size: 22px;
      color: #ffffff;
      line-height: 36px;
      width: 528px;
      text-align: justify;
      text-indent: 2em;
    }
    > div:nth-child(2) {
      text-indent: 2em;
      padding-top: 100px;
      width: 561px;
      margin-right: 16px;
      text-align: justify;
    }
  }
  .img {
    position: absolute;
    top: -61px;
    right: 40px;
    border: 12px solid #fff;
    // padding: 16px;
    box-sizing: border-box;
    width: 561px;
    height: 227px;
  }
}
</style>
